module.exports = __webpack_public_path__ + "static/media/logo-coquetel.d85cb33e.png";